import "./polyfills";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose, combineReducers } from "redux";
import thunk from "redux-thunk";
import "./styles/index.css";
import App from "./components/App";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import authReducer from "./store/reducers/authReducer";
import dashboardReducer from "./store/reducers/dashboardReducer";
import wikiReducer from "./store/reducers/wikiReducer";
import leaveReducer from "./store/reducers/leaveReducer";
import serviceAccountReducer from "./store/reducers/serviceAccountReducer";
import communityReducer from "./store/reducers/communityReducer";
import projectReducer from "./store/reducers/projectReducer";
import tenantReducer from "./store/reducers/tenantReducer";
import securityReducer from "./store/reducers/securityReducer";
import postProcessorReducer from "./store/reducers/postProcessorReducer";
import "./styles/constants.css";
import "./components/Common/Controls/Styles/Controls.css";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

//Add more reducers here when needed
const rootReducer = combineReducers({
  authData: authReducer,
  dashboardData: dashboardReducer,
  wikiData: wikiReducer,
  leaveData: leaveReducer,
  communityData: communityReducer,
  projectData: projectReducer,
  tenantData: tenantReducer,
  securityData: securityReducer,
  serviceAccountData: serviceAccountReducer,
  postProcessorData: postProcessorReducer,
});

//Use thunk for handling async requests
const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
